import { useState } from 'react';
import PropTypes from 'prop-types';

import Container from '../../../Core/Container';
import RichText from '../../../Core/RichText';

import {
  Wrapper,
  AccordionWrapper,
  StyledAccordionItem,
  StyledAccordionItemTitle,
  StyledAccordionItemButton,
  StyledAccordionBody,
} from './styles';

const VideoTutorialTransript = ({
  transcript,
  showTranscriptLabel,
  hideTranscriptLabel,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Wrapper>
      <Container className="auto-margin">
        <AccordionWrapper allowMultipleExpanded allowZeroExpanded>
          <StyledAccordionItem>
            <StyledAccordionItemTitle
              onClick={() => {
                if (isOpen) {
                  setIsOpen(false);
                } else {
                  setIsOpen(true);
                }
              }}
            >
              <StyledAccordionItemButton>
                <p>{!isOpen ? showTranscriptLabel : hideTranscriptLabel}</p>
              </StyledAccordionItemButton>
            </StyledAccordionItemTitle>
            <StyledAccordionBody>
              <RichText document={transcript} />
            </StyledAccordionBody>
          </StyledAccordionItem>
        </AccordionWrapper>
      </Container>
    </Wrapper>
  );
};

VideoTutorialTransript.propTypes = {
  transcript: PropTypes.shape().isRequired,
  showTranscriptLabel: PropTypes.string.isRequired,
  hideTranscriptLabel: PropTypes.string.isRequired,
};

export default VideoTutorialTransript;
